<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20">
        <b>BIÊN BẢN BÀN GIAO THIẾT BỊ</b>
      </p>
      <p class="txt-center">
        (Số: <mark>{{ dataAppendix.code }}</mark
        >)
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          Hợp đồng hợp tác chấp nhận thanh toán số:<mark>{{
            dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
          }}</mark>
          (sau đây được viết tắt là "Hợp đồng") ký ngày
          <mark v-if="dataAppendix?.isNganluongContract">
            {{ dataAppendix?.dateSignContract | formatDate }}</mark
          >
          <mark v-else>{{
            dataContract.effectiveFromDTO
              ? dataContract.effectiveFromDTO
              : dataContract.dateSign | formatDate
          }}</mark>
        </li>
      </ol>
      <p>
        Hôm nay, ngày
        <span v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</span>
        <span v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</span>
        <span v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</span>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng'
            : 'tại Công ty Cổ phần Công nghệ Vi Mô'
        }}:
      </p>
      <b>Chúng tôi gồm: </b>
      <p class="fonsize-16 txt-tranf">
        <b><mark>Bên bàn giao (Bên A): </mark></b>
      </p>
      <div>
        <ul class="form">
          <li>
            Ông:
            <b
              v-if="
                dataAppendix?.dateSignAppendixDTO ||
                dataAppendix?.dateCreatedAppendixDTO ||
                dataContract?.effectiveFromDTO
                  ? (dataAppendix?.dateSignAppendixDTO ||
                      dataAppendix?.dateCreatedAppendixDTO ||
                      dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                  : new Date() < new Date('2026-01-07')
              "
              >ĐỖ CÔNG DIỄN</b
            >
            <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          </li>
          <li>
            Chức vụ:
            <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b>
          </li>
        </ul>
        <span
          >Đại diện cho:
          <b v-if="!checkCreatedDateNganluong(dataAppendix)">CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
          ><b v-else>CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b></span
        >
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
      </div>
      <p class="fonsize-16 txt-tranf flex">
        <span
          ><b><mark>Bên nhận bàn giao (Bên B):</mark></b></span
        >
      </p>
      <ul class="form">
        <li>
          Ông (Bà): <b> {{ customerInfo ? customerInfo.customerName : '' }}</b>
        </li>
        <li>Chức vụ: {{ customerInfo ? customerInfo.position : '' }}</li>
        <li>
          Đại diện cho: <b>{{ customerInfo.merchantName }}</b>
        </li>
      </ul>

      <p>&nbsp;</p>
      <p>Nội dung bàn giao như sau:</p>
      <p>
        Bên A tiến hành bàn giao<mark>{{ dataAppendix.appendixHandOver.devices.length }}</mark
        >thiết bị cho bên B, cụ thể:
      </p>
      <div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr class="bg-head">
                <th align="center">STT</th>
                <th align="center">Loại thiết bị</th>
                <th align="center">Tên viết tắt</th>
                <th align="center">Serial thiết bị</th>
                <th align="center">Tình trạng thiết bị</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dataAppendix.appendixHandOver.devices" :key="index">
                <td align="center">{{ index + 1 }}</td>
                <td class="text-left">{{ item.displayName }}</td>
                <td>{{ item.name }}</td>
                <td class="text-left">{{ item.serialNumber }}</td>
                <td>Hoạt động</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <ol class="form-style2">
        <li>
          <b
            ><span
              >Lý do bàn giao:
              {{
                dataAppendix.appendixHandOver.handOverReason
                  ? dataAppendix.appendixHandOver.handOverReason
                  : '' | transformData(Config.reasonHandOver)
              }}</span
            ></b
          >
        </li>
        <li>
          Bên A bảo đảm cung cấp hàng hoá đúng nhãn hiệu của hãng sản xuất. Sản phẩm được kiểm tra,
          cài đặt và đảm bảo hoạt động tốt với hệ thống thanh toán thẻ mPOS.vn trước khi bàn giao
          cho Bên B.
        </li>
        <li>
          Biên bản được lập thành 02 (hai) bản, bên A giữ 01(một) bản, bên B giữ 01 (một) bản có giá
          trị pháp lý như nhau.
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {
        Config,
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return this.appendix
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
